export default "dist/images/block-pricing-box-compact.1cecd08.png";